<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="container">
      <user-editor ref="editor" v-model="form"></user-editor>
      <div class="text-right">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import UserEditor from "../components/UserEditor";
import { baanRueJaiClient } from "@/dependencies";
import { DateTime } from "luxon";

export default {
  components: {
    PageWrapper,
    ScButton,
    UserEditor
  },
  data() {
    const title = "เพิ่มผู้ใช้";
    const form = {
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      gender: null,
      birthDate: null
    };

    return {
      title,
      form
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {},
    async handleClickSave() {
      const { editor } = this.$refs;

      editor.$v.$touch();

      if (editor.$v.$invalid) {
        return;
      }
      try {
        await this.createUser();
        this.$router.push({ name: "UserListPage" });
      } catch (err) {
        console.error(err);
        alert("ไม่สามารถเพิ่มผู้ใช้ได้");
      }
    },
    async createUser() {
      const {
        email,
        password,
        firstName,
        lastName,
        gender,
        birthDate
      } = this.form;

      const form = {
        email,
        password,
        firstName,
        lastName,
        gender,
        birthDate: birthDate ? birthDate.toISO() : null
      };

      const response = await baanRueJaiClient.admin.users.post(form);

      return response;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/users/pages/UserCreatePage.vue